import AOS from "aos";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
const About = () => {
  const [termandcontiondata, setTermsandconditiondata] = useState(null)
  useEffect(() => {
    featchTermsandcondition()
  }, [])
  const featchTermsandcondition = () => {
    axios.get(`${process.env.REACT_APP_BASE_URL}terms_condition_list`)
      .then((result) => {
        const res = result.data.data;
        if (Array.isArray(res) && res.length > 0) {
          setTermsandconditiondata(res[0]);
        }
      }).catch((err) => {
        console.log(err)
      });
  }
  useEffect(() => {
    AOS.init({ duration: 1500, once: true });

    const loader = document.getElementById("preloader");
    if (loader) {
      setTimeout(() => {
        loader.style.display = "none";
      }, 1000); // 1 sec loader hide
    }
  }, []);
  return (
    <div>
      <div className="page_wrapper">
        <div id="preloader">
          <div id="loader" />
        </div>
        <header className="white_header">
          <div className="container">
            <nav className="navbar navbar-expand-lg">
              <Link to={"/"} className="navbar-brand">
                <img src="images/Logosmall.png" alt="image" />
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <span className="navbar-toggler-icon">
                  <div className="toggle-wrap">
                    <span className="toggle-bar" />
                  </div>
                </span>
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item">
                    <Link to={"/"} className="nav-link">
                      Home
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>
            {/* navigation end */}
          </div>
          {/* container end */}
        </header>
        {/* Why we are section Start */}
        <section className="row_am why_we_section" data-aos="fade-in">
          <div className="why_inner">
            <div className="container">
              <div
                className="section_title"
                data-aos="fade-up"
                data-aos-duration={1500}
                data-aos-delay={100}>

                {termandcontiondata?.description && (
                 
                    <div
                        style={{ color: 'black' }}  
                      dangerouslySetInnerHTML={{
                        __html: termandcontiondata.description
                           .replace(/<h1/g, '<h1 style="color: black; "')
                          .replace(/<h2/g, '<h2 style="color: black; font-size:25px"')
                          .replace(/<h3/g, '<h3 style="color: black; font-size:25px"')
                      }}
                    />
              
      )}
              
              </div>
            </div>
          </div>
        </section>
        {/* Footer-Section start */}
        <footer>
          <div className="top_footer" id="contact">
            {/* animation line */}
            <div className="anim_line dark_bg">
              <span>
                <img src="images/anim_line.png" alt="anim_line" />
              </span>
              <span>
                <img src="images/anim_line.png" alt="anim_line" />
              </span>
              <span>
                <img src="images/anim_line.png" alt="anim_line" />
              </span>
              <span>
                <img src="images/anim_line.png" alt="anim_line" />
              </span>
              <span>
                <img src="images/anim_line.png" alt="anim_line" />
              </span>
              <span>
                <img src="images/anim_line.png" alt="anim_line" />
              </span>
              <span>
                <img src="images/anim_line.png" alt="anim_line" />
              </span>
              <span>
                <img src="images/anim_line.png" alt="anim_line" />
              </span>
              <span>
                <img src="images/anim_line.png" alt="anim_line" />
              </span>
            </div>
            {/* container start */}
            <div className="container">
              {/* row start */}
              <div className="row">
                {/* footer link 1 */}
                <div className="col-lg-4">
                  <div className="abt_side">
                    <div className="logo">
                      <img src="images/Logosmall.png" alt="image" />
                    </div>
                    <ul>
                      <li>
                        <a href="#">info@oriveri.com</a>
                      </li>
                      {/* <li><a href="#">+1-900-123 4567</a></li> */}
                    </ul>
                    <ul className="social_media">
                      <li>
                        <a href="#">
                          <i className="icofont-facebook" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="icofont-linkedin" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* footer link 3 */}
                {/* <div className="col-lg-3">
                  <div className="links">
                    <ul>
                      <li>
                        <Link
                          to="/contactowner"
                          style={{ color: "#3a8524", fontWeight: "bold" }}>
                          For Brand Owners
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/scanqr"
                          style={{ color: "#3a8524", fontWeight: "bold" }}>
                          Scan Qr
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div> */}
                <div className="col-lg-3">
                  <div className="links">
                    <ul>
                      <li>
                        <Link to="/contactowner" style={{ color: "yellow", fontWeight: "bold" }}>
                          For Brand Owners
                        </Link>
                      </li>
                      <li>
                        <Link to="/scanqr" style={{ color: "yellow", fontWeight: "bold" }}>
                          Scan Qr
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* footer link 2 */}
                <div className="col-lg-3">
                  <div className="links">
                    <ul>
                      <li>
                        <Link to="/contact">Contact us</Link>
                      </li>
                      <li>
                        <Link to="/terms&conditions">
                          Terms &amp; conditions
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacy">Privacy policy</Link>
                      </li>
                    </ul>
                  </div>
                </div>



                {/* footer link 4 */}
                <div className="col-lg-2">
                  <div className="try_out">
                    <div
                      style={{ borderRadius: "10px 10px 0px 0px" }}
                      className="responsive_div">
                      <h4 className="responsive_heading">
                        <b>Download</b> the <b>Application</b> for a{" "}
                        <b>Secured</b>, <b>Swift</b>, and{" "}
                        <b>Smooth experience</b>!
                      </h4>
                      <ul style={{ marginBottom: "0px" }} className="app_btn">
                        <li>
                          <a href="https://apps.apple.com/us/app/oriveri/id6741198221">
                            <img
                              src="images/appstore_blue.png"
                              alt="App Store"
                            />
                          </a>
                        </li>
                        <li>
                          <a href="https://play.google.com/store/apps/details?id=com.oriveri.com">
                            <img
                              style={{ padding: "3px" }}
                              src="images/googleplay_blue.png"
                              alt="Google Play"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* row end */}
            </div>
            {/* container end */}
          </div>
          {/* last footer */}
          <div className="bottom_footer">
            {/* container start */}
            <div className="container">
              {/* row start */}
              <div className="row">
                <div className="col-md-6">
                  <p>© Copyrights 2025. All rights reserved.</p>
                </div>
                <div className="col-md-6">
                  <p className="developer_text">
                    Design &amp; developed by{" "}
                    <a
                      href="https://themeforest.net/user/kalanidhithemes"
                      target="blank">
                      Logical Softtech Pvt. Ltd.
                    </a>
                  </p>
                </div>
              </div>
              {/* row end */}
            </div>
            {/* container end */}
          </div>
          {/* go top button */}
          <div className="go_top">
            <span>
              <img src="images/go_top.png" alt="image" />
            </span>
          </div>
        </footer>
        {/* Footer-Section end */}
        {/* VIDEO MODAL */}
        <div
          className="modal fade youtube-video"
          id="myModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button
                id="close-video"
                type="button"
                className="button btn btn-default text-right"
                data-dismiss="modal">
                <i className="icofont-close-line-circled" />
              </button>
              <div className="modal-body">
                <div id="video-container" className="video-container">
                  <iframe
                    id="youtubevideo"
                    src="#"
                    width={640}
                    height={360}
                    frameBorder={0}
                    allowFullScreen
                  />
                </div>
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
